





























import { defineComponent, PropType } from '@vue/composition-api';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import UserAvatar from '@front-app/components/user/avatar.vue';
import { Size } from '@front-app/components/constants';
import { getUsername } from '@front-app/util/user';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import UserLink from '../buttons/UserLink.vue';

export default defineComponent({
	components: {
		UserLink,
		UserAvatar,
	},
	props: {
		users: {
			type: Array as PropType<PartialUser[]>,
			required: true,
		},
		isVertical: Boolean,
	},
	setup(props, ctx) {
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);
		return {
			getUsernameInternal,
			Size,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
		};
	},
});
